import { Stack, Typography, useTheme } from '@mui/material';
import EmailSummaryCard from '@/components/Email/EmailSummaryCard';
import { useEmailTimeline } from '@/queries/prospectDetails';
import EmailTimelineSkeleton from './EmailTimelineSkeleton';
import ProspectDetailsErrorPage from './ProspectDetailsErrorPage';

interface Props {
    prospectId?: string;
}

export default function EmailTimeline({ prospectId }: Props) {
    const theme = useTheme();

    const {
        data: allActivities = [],
        isPending,
        isError,
        isFetching,
        refetch,
    } = useEmailTimeline(prospectId);

    if (isPending) {
        return <EmailTimelineSkeleton />;
    }

    if (isError) {
        return (
            <ProspectDetailsErrorPage
                message="There was an error fetching the email timeline"
                onRetry={refetch}
                isRetrying={isFetching}
            />
        );
    }

    return (
        <Stack
            spacing={2}
            p={3}
            m={3}
            sx={{
                border: `1px solid ${theme.palette.neutral.borderColor}`,
                borderRadius: '8px',
                backgroundColor: theme.palette.neutral.white,
            }}
        >
            <Typography variant="h3">Email timeline</Typography>
            {allActivities.map((activity) => (
                <EmailSummaryCard activity={activity} key={activity.activityId} />
            ))}
        </Stack>
    );
}
